module.exports = __webpack_public_path__ + "static/DIR_logo_Name_White-4ce90123fcc7c7f9eb95f2bb924acc44.png";